import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import './input.scss';

const Input = memo(
  ({
    label,
    type = 'text',
    value,
    containerClassName,
    placeholder,
    ...props
  }) => {
    const renderInput = useMemo(() => {
      if (type === 'select') {
        return <Select {...props} value={value} />;
      }
      if (type === 'file') {
        return (
          <div>
            <label className="ui-file-button btn btn-primary">
              <input className="ui-input" type={type} {...props} hidden />
              <span>{placeholder}</span>
            </label>
          </div>
        );
      }
      return (
        <input
          className="ui-input"
          type={type}
          value={value || ''}
          {...props}
        />
      );
    }, [type, value, props, placeholder]);

    return (
      <div className={containerClassName}>
        <label>{label}</label>
        {renderInput}
      </div>
    );
  },
);

Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  containerClassName: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
};

export default Input;
